module.exports = __webpack_public_path__ + "static/media/Cadets.b9beea1b.jpg";